var map = {
	"./de-DE/btn_select-text-random.png": "f540",
	"./en-GB/btn_select-text-random.png": "759f",
	"./en-US/btn_select-text-random.png": "cb32",
	"./es-ES/btn_select-text-random.png": "ebb3",
	"./es-MX/btn_select-text-random.png": "92f3",
	"./fr-CA/btn_select-text-random.png": "1c16",
	"./fr-FR/btn_select-text-random.png": "3b8b",
	"./it-IT/btn_select-text-random.png": "77e5",
	"./ja-JP/btn_select-text-random.png": "d6d6",
	"./pt-BR/btn_select-text-random.png": "c711",
	"./zh-TW/btn_select-text-random.png": "6da0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5044";